<template>
	<div class="SkeletonLoading"></div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.SkeletonLoading {
	background: linear-gradient(-80deg, #fff 10%, #fafafa 19%, #fafafa 21%, #fff 30%);
	border-radius: var(--border-radius-x-small);
	background-size: 800px 100%;
	animation: 5s linear infinite forwards running c_loadingAnimation;
	position: relative;
	overflow: hidden;
	&.white {
		background: linear-gradient(-80deg, #fff 10%, #fafafa 19%, #fafafa 21%, #fff 30%);
		background-size: 800px 100%;
	}

	&.border {
		border: 1px solid var(--color-border-light);
		&-bottom {
			border-bottom: 1px solid var(--color-border-light);
		}
	}

	// 사이즈 관련 START
	&.card {
		width: 100%;
		height: 18.8rem;
		aspect-ratio: 1;
		border-radius: var(--border-radius-small);
	}
	&.list_card {
		width: 100%;
		height: 75rem;
		aspect-ratio: 1;
		border-radius: var(--border-radius-small);
	}
	&.insite-card {
		width: 100%;
		height: 26.4rem;
		aspect-ratio: 1;
		border-radius: var(--border-radius-small);
	}
	&.master-list {
		width: 100%;
		height: 300rem;
	}
	&.rect {
		width: 100%;
		height: auto;
		aspect-ratio: 1;
		border-radius: var(--border-radius-small);
	}
	&.title {
		height: calc(var(--font-s-xx-large) * 1.3);
		width: 40%;
		&-small {
			@extend .title;
			width: 30%;
		}
		&-mid {
			@extend .title;
			width: 50%;
		}
		&-large {
			@extend .title;
			width: 80%;
		}
		&-full {
			@extend .title;
			width: 100%;
		}
	}
	&.text {
		height: calc(var(--font-s-mid) * 1.3);
		width: 60%;
		&-small {
			@extend .text;
			width: 30%;
		}
		&-mid {
			@extend .text;
			width: 50%;
		}
		&-large {
			@extend .text;
			width: 80%;
		}
		&-full {
			@extend .text;
			width: 100%;
		}
	}
	&.subtext {
		height: calc(var(--font-s-mid) * 1.3);
		width: 60%;
		&-small {
			@extend .subtext;
			width: 30%;
		}
		&-mid {
			@extend .subtext;
			width: 50%;
		}
		&-large {
			@extend .subtext;
			width: 80%;
		}
		&-full {
			@extend .subtext;
			width: 100%;
		}
	}
	&.tag {
		height: calc(var(--font-s-mid) * 1.3);
		width: 7rem;
	}
	&.input {
		height: calc(var(--common-height) * 0.9);
		border-radius: var(--border-radius-small);
		width: 100%;
	}
	// 사이즈 관련 END
}

@keyframes c_loadingAnimation {
	0% {
		background-position: -800px 0;
	}
	100% {
		background-position: 800px 0;
	}
}
</style>
